<script>
  import TextInput from '../../../../components/inputs/text';
  import TextAreaInput from '../../../../components/inputs/textarea';
  import ProgramInput from '../../../../components/inputs/program';
  import CoordinatorInput from '../../../../components/inputs/coordinator';
  import CategoryInput from '../../../../components/inputs/category';
  import AnnualScheduleInput from '../../../../components/inputs/schedule';
  import DateInput from '../../../../components/inputs/date';
  import TimeInput from '../../../../components/inputs/time';
  import DateTimeInput from '../../../../components/inputs/datetime';
  import LeaderInput from '../../../../components/inputs/leader';
  import Form from '../../../../components/inputs/form';
  import Switch from '../../../../components/inputs/switch';

  export let value;
  export let review = false;
</script>

<div>
  <Form>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-6">
        <div class="form-group">
          <DateTimeInput
            bind:value="{value.registrationOpenDate}"
            label="Registration Open Date"
            placeholder="Registration Open Date"
          ></DateTimeInput>
        </div>
      </div>
    </div>

    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="form-group">
          <Switch
            bind:value="{value.constraintAllowEarlyRegistration}"
            label="Open for Early Registration?"
            name="constraint-allow-early-registration"
          ></Switch>
        </div>
      </div>
      {#if value.constraintAllowEarlyRegistration}
      <div class="cell small-6">
        <div class="form-group">
          <DateTimeInput
            bind:value="{value.earlyRegistrationOpenDate}"
            label="Early Registration Open Date"
            placeholder="Early Registration Open Date"
          ></DateTimeInput>
        </div>
      </div>
      {/if}
    </div>

    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="form-group">
          <Switch
            bind:value="{value.constraintAllowGroupRegistration}"
            label="Allow Group Registration?"
            name="constraint-allow-group-registration"
          ></Switch>
        </div>
      </div>
      {#if value.constraintAllowGroupRegistration}
      <div class="cell small-3">
        <div class="form-group">
          <TextInput
            bind:value="{value.constraintCapacityGroup}"
            label="Group Event Capacity"
            placeholder="Group Event Capacity"
          ></TextInput>
        </div>
      </div>
      {/if}
    </div>

    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="form-group">
          <Switch
            bind:value="{value.constraintPrivate}"
            label="Private Event?"
            name="constraint-private-event"
          ></Switch>
        </div>
      </div>
    </div>

    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <div class="form-group">
          <Switch
            bind:value="{value.published}"
            label="Published?"
            name="constraint-published"
          ></Switch>
        </div>
      </div>
    </div>
  </Form>
</div>
